var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailNotification = function SvgMailNotification(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h10.1a5.1 5.1 0 0 0 0 2H4v12h16V9.9q.575-.125 1.075-.35T22 9v9q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm8-9 3.65-2.275q.35.325.763.563.412.237.862.412l-4.75 2.975q-.25.15-.525.15-.274 0-.525-.15L4 8V6zm7-3a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 16 5q0-1.25.875-2.125A2.9 2.9 0 0 1 19 2q1.25 0 2.125.875T22 5t-.875 2.125A2.9 2.9 0 0 1 19 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailNotification);
export { ForwardRef as ReactComponent };